import * as angular from "angular";
import * as _ from "lodash";
import {CommonsService} from "../services/commons-service.service";

angular
    .module('bringoz.admin.commons')
    .filter('bringozAddress', bringozAddress);

function bringozAddress($translate, splitService, commonsService: CommonsService) {
  return function bringozAddressFilter(address, noValueEnabled) {

    if (address) {
      let countryCode = splitService.getCountryCode();

      let house = _.get(address, 'house', '');
      let street = _.get(address, 'street', '');
      let neighborhood = _.get(address, 'neighborhood', '');
      let city = _.get(address, 'city', '');
      let state = _.get(address, 'state', '');
      let zipCode = _.get(address, 'zipCode', '');

      let formattedAddress = '';

      if (countryCode === 'IL') {
        if (street) {
          formattedAddress += street;
          if (house) {
            formattedAddress += (' ' + house);
          }
        }
        if (city) {
          formattedAddress += (', ' + city);
        }
      } else {
        if(countryCode === 'GB') {
          if (street) {
            if (house) {
              formattedAddress += (house + ' ');
            }
            formattedAddress += street;
          }
          if (neighborhood) {
            formattedAddress += (', ' + neighborhood);
          }
          if (city) {
            formattedAddress += (', ' + city);
          }
          if (state) {
            formattedAddress += (', ' + state);

            if (zipCode) {
              formattedAddress += (' ' + zipCode);
            }
          } else {
            if (zipCode) {
              formattedAddress += (', ' + zipCode);
            }
          }
        }else{
          if (street) {
            if (house) {
              formattedAddress += (house + ' ');
            }
            formattedAddress += street;
          }
          if (city) {
            formattedAddress += (', ' + city);
          }
          if (neighborhood) {
            formattedAddress += (', ' + neighborhood);
          }
          if (state) {
            formattedAddress += (', ' + state);

            if (zipCode) {
              formattedAddress += (' ' + zipCode);
            }
          } else {
            if (zipCode) {
              formattedAddress += (', ' + zipCode);
            }
          }
        }
      }

      return commonsService.capitalize(formattedAddress);
    } else {
      return noValueEnabled ? undefined : $translate.instant('No Address');
    }
  };
}
